module.exports = __webpack_public_path__ + "static/media/checked.2ec00e6b.svg";